import React from 'react'
import labels from "../../sectionLabels";
import {getColor} from "./colorForScorePath";

export const ScoreLegend = ({
                       scorePaths,
                       isVertical=false,
                       className,
                       style={},
                       ...props
                     }) => {
  return <div
    style={{
      ...style,
      ...(isVertical ? {
        // borderLeft: '1px solid #EEE',
        // paddingLeft: '12px'
      } : {
        textAlign: 'center'
      })}}
    className={`score-legend ${className || ""}`}
    {...props}>
    {
      scorePaths.map(scorePath => {
        return (
          <span key={`chartLabel-${scorePath}`}
                style={{
                  display: isVertical ? 'block' : 'inline-block',
                  marginBottom: '5px',
                  ...(isVertical ? {
                    display: 'block',
                    marginRight: '15px'
                  } : {
                    display: 'inline-block'
                  })
                }}>
            <span className="dot" style={{backgroundColor: getColor(scorePath)}} /> {labels[scorePath]}
          </span>
        );
      })
    }
    </div>
}
